import ModalView from 'common-views/ModalView';
import template  from 'dashboard/forms/modal/migrate-form-instance.ejs';
import $ from 'jquery';
import constants from 'Constants';

class MigrateFormInstanceModal extends ModalView {

    initialize(){
        super.initialize();
        this.template = template;
        this._selectedMigrationType = 'fix';
    }

    render(){
        return new Promise((resolve, reject) => {
            const settings = this.settings;
            const _self = this;

            settings.buttons = [
                {                    
                    text: 'OK',
                    class: 'btn-save-map-versions',
                    click: () => {
                        resolve(_self._selectedMigrationType);
                        this.closeModal();
                    }
                },
                {
                    text: 'Cancel',
                    click: () => {
                        resolve();
                        this.closeModal();
                    }
                }
            ];

            settings.width = '250';
            settings.open = () => {
                _self.bindEvents();
            };

            if(this.template) {
                this.$el.html(this.template());
            }
            super.render();
        });
    }

    bindEvents(){
        const _self = this;
        $(`${constants.DIALOG_ID} input:radio`).change((e)=>{
            if (e.currentTarget.checked){
                _self._selectedMigrationType = e.currentTarget.value;
            }
        });
    }
}

export default MigrateFormInstanceModal;